<div *ngIf="isAllowed; else notAllowed">
  <!-- Spinner de carga principal usando el spinner del sistema -->
  <div *ngIf="isLoading" class="h-screen w-full flex items-center justify-center">
    <div class="flex flex-col items-center space-y-4">
      <div class="h-12 w-12 border-4 border-[var(--color-brand-400)] border-t-transparent rounded-full animate-spin"></div>
      <span class="text-[var(--color-brand-400)] text-lg font-medium">Cargando datos...</span>
    </div>
  </div>

  <!-- Contenido principal - solo se muestra cuando no está cargando -->
  <div *ngIf="!isLoading" class="h-screen w-full overflow-y-auto flex flex-col items-stretch relative max-w-full pt-16 sm:pt-8 px-3 sm:px-0">
    <div class="w-full flex flex-col items-center flex-1">
      <section class="w-full max-w-full md:max-w-[95%] lg:max-w-[90%] mx-auto mb-10 mt-4">
        <h2 class="text-2xl font-semibold mb-4 text-gray-900 dark:text-white">Estadísticas de acceso de usuario (últimos {{selectedDays}} días)</h2>
        <div *ngIf="loginStats && loginStats.general_stats as stats" class="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6">
          <div class="bg-[#DCEAFF] dark:bg-gray-800 rounded-lg p-4 shadow flex flex-col items-center">
            <span class="text-3xl font-bold text-gray-900 dark:text-white">{{stats.total_logins}}</span>
            <span class="text-gray-600 dark:text-gray-300">Total de inicios de sesión</span>
          </div>
          <div class="bg-[#DCEAFF] dark:bg-gray-800 rounded-lg p-4 shadow flex flex-col items-center">
            <span class="text-3xl font-bold text-gray-900 dark:text-white">{{stats.successful_logins}}</span>
            <span class="text-gray-600 dark:text-gray-300">Éxitos</span>
          </div>
          <div class="bg-[#DCEAFF] dark:bg-gray-800 rounded-lg p-4 shadow flex flex-col items-center">
            <span class="text-3xl font-bold text-gray-900 dark:text-white">{{stats.failed_logins}}</span>
            <span class="text-gray-600 dark:text-gray-300">Fallidos</span>
          </div>
          <div class="bg-[#DCEAFF] dark:bg-gray-800 rounded-lg p-4 shadow flex flex-col items-center">
            <span class="text-3xl font-bold text-gray-900 dark:text-white">{{stats.blocked_logins}}</span>
            <span class="text-gray-600 dark:text-gray-300">Bloqueados</span>
          </div>
          <div class="bg-[#DCEAFF] dark:bg-gray-800 rounded-lg p-4 shadow flex flex-col items-center">
            <span class="text-3xl font-bold text-gray-900 dark:text-white">{{stats.email_logins}}</span>
            <span class="text-gray-600 dark:text-gray-300">Inicios por email</span>
          </div>
          <div class="bg-[#DCEAFF] dark:bg-gray-800 rounded-lg p-4 shadow flex flex-col items-center">
            <span class="text-3xl font-bold text-gray-900 dark:text-white">{{stats.microsoft_logins}}</span>
            <span class="text-gray-600 dark:text-gray-300">Inicios por Microsoft</span>
          </div>
          <div class="bg-[#DCEAFF] dark:bg-gray-800 rounded-lg p-4 shadow flex flex-col items-center">
            <span class="text-3xl font-bold text-gray-900 dark:text-white">{{stats.unique_users}}</span>
            <span class="text-gray-600 dark:text-gray-300">Usuarios únicos</span>
          </div>
          <div class="bg-[#DCEAFF] dark:bg-gray-800 rounded-lg p-4 shadow flex flex-col items-center">
            <span class="text-3xl font-bold text-gray-900 dark:text-white">{{stats.unique_ips}}</span>
            <span class="text-gray-600 dark:text-gray-300">IPs únicas</span>
          </div>
        </div>
        <div *ngIf="loginLogs.length > 0">
          <div class="mb-4 flex flex-col sm:flex-row gap-3 sm:gap-4 sm:items-end">
            <!-- Filtro por período de días -->
            <div class="flex-shrink-0 w-full sm:w-auto">
              <label for="daysSelect" class="block mb-1 text-sm font-medium text-gray-700 dark:text-gray-200">Período:</label>
              <select id="daysSelect" [(ngModel)]="selectedDays" (change)="onDaysChange()"
                class="w-full sm:min-w-[120px] sm:w-auto appearance-none rounded-lg border border-brand-400 bg-white dark:bg-gray-800 dark:text-white px-3 py-2 focus:outline-none focus:ring-1 focus:ring-[var(--color-brand-400)] focus:border-brand-400 transition">
                <option *ngFor="let option of dayOptions" [ngValue]="option.value">{{option.label}}</option>
              </select>
            </div>

            <!-- Filtro por usuario -->
            <div class="flex-shrink-0 w-full sm:w-auto">
              <label for="userSelect" class="block mb-1 text-sm font-medium text-gray-700 dark:text-gray-200">Filtrar por usuario:</label>
              <div class="w-full sm:inline-block">
                <ng-container *ngIf="!isUsersLoading; else loadingUsers">
                  <select id="userSelect" [(ngModel)]="selectedUser" (change)="onUserChange()"
                    class="w-full sm:w-auto appearance-none rounded-lg border border-brand-400 bg-white dark:bg-gray-800 dark:text-white px-3 py-2 focus:outline-none focus:ring-1 focus:ring-[var(--color-brand-400)] focus:border-brand-400 transition sm:min-w-[200px]">
                    <option [ngValue]="null" [selected]="!selectedUser">Todos</option>
                    <option *ngFor="let user of uniqueUsers" [ngValue]="user">{{user.name}} ({{user.email}})</option>
                  </select>
                </ng-container>
                <ng-template #loadingUsers>
                  <div class="flex items-center gap-2 py-2 px-3 w-full sm:min-w-[200px] border border-brand-400 rounded-lg">
                    <div class="h-5 w-5 border-2 border-brand-400 border-t-transparent rounded-full animate-spin"></div>
                    <span class="text-brand-400 text-sm">Cargando usuarios...</span>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
          
          <!-- Indicador de filtro activo -->
          <div *ngIf="isFilteringByDates()" class="mb-2 p-2 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-200 dark:border-blue-800">
            <div class="flex items-center gap-2 text-sm text-blue-700 dark:text-blue-300">
              <span class="w-2 h-2 bg-blue-500 rounded-full"></span>
              <span>Filtro de fechas activo: mostrando {{filteredLoginLogs.length}} de {{allLoginLogs.length}} registros totales</span>
            </div>
          </div>
          
          <h3 class="text-lg font-semibold mb-2 text-gray-900 dark:text-white">
            Últimos accesos 
            <span class="text-sm font-normal text-gray-500 dark:text-gray-400">
              ({{filteredLoginLogs.length}} registros encontrados)
            </span>
          </h3>
          <div class="overflow-x-auto -mx-3 sm:mx-0">
            <table class="min-w-full text-sm text-left" *ngIf="loginLogs.length > 0; else noLogsFound">
              <thead>
                <tr class="bg-gray-100 dark:bg-gray-800">
                  <th class="p-2 sm:p-3 whitespace-nowrap text-gray-700 dark:text-gray-200">Fecha</th>
                  <th class="p-2 sm:p-3 whitespace-nowrap hidden sm:table-cell text-gray-700 dark:text-gray-200">IP</th>
                  <th class="p-2 sm:p-3 whitespace-nowrap text-gray-700 dark:text-gray-200">Método</th>
                  <th class="p-2 sm:p-3 whitespace-nowrap text-gray-700 dark:text-gray-200">Estado</th>
                  <th class="p-2 sm:p-3 whitespace-nowrap hidden md:table-cell text-gray-700 dark:text-gray-200">Dispositivo</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let log of loginLogs" class="border-b border-gray-200 dark:border-gray-700">
                  <td class="p-2 sm:p-3 whitespace-nowrap text-xs sm:text-sm text-gray-800 dark:text-gray-100">{{log.logged_in_at | date:'short'}}</td>
                  <td class="p-2 sm:p-3 whitespace-nowrap text-xs sm:text-sm hidden sm:table-cell text-gray-800 dark:text-gray-100">{{log.ip_address}}</td>
                  <td class="p-2 sm:p-3 whitespace-nowrap text-xs sm:text-sm text-gray-800 dark:text-gray-100">{{log.login_method}}</td>
                  <td class="p-2 sm:p-3 whitespace-nowrap text-xs sm:text-sm">
                    <span [ngClass]="{'text-green-600 dark:text-green-400': log.status === 'success', 'text-red-600 dark:text-red-400': log.status !== 'success'}">{{log.status}}</span>
                  </td>
                  <td class="p-2 sm:p-3 whitespace-nowrap text-xs sm:text-sm hidden md:table-cell text-gray-800 dark:text-gray-100">{{log.device}}</td>
                </tr>
              </tbody>
            </table>
            
            <ng-template #noLogsFound>
              <div class="text-center py-8 text-gray-500 dark:text-gray-400">
                <p class="text-lg mb-2">No se encontraron registros</p>
                <p class="text-sm">
                  <span *ngIf="selectedUser && selectedDays">
                    No hay accesos de <strong>{{selectedUser.name}}</strong> en los últimos <strong>{{selectedDays}} días</strong>
                  </span>
                  <span *ngIf="!selectedUser && selectedDays">
                    No hay accesos en los últimos <strong>{{selectedDays}} días</strong>
                  </span>
                  <span *ngIf="selectedUser && !selectedDays">
                    No hay accesos de <strong>{{selectedUser.name}}</strong>
                  </span>
                </p>
              </div>
            </ng-template>
          </div>
          
          <!-- Paginación -->
          <div *ngIf="filteredLoginLogs.length > 0" class="flex flex-col sm:flex-row gap-2 mt-4 justify-between sm:justify-end items-center">
            <!-- Info de registros en mobile -->
            <div class="text-sm text-gray-600 dark:text-gray-400 sm:hidden">
              Página {{loginLogsPage}} de {{loginLogsLastPage}}
            </div>
            
            <!-- Controles de paginación -->
            <div class="flex gap-2 items-center">
              <button class="px-3 py-2 rounded bg-gray-200 dark:bg-gray-700 text-sm font-medium text-gray-800 dark:text-white disabled:opacity-50" 
                      [disabled]="loginLogsPage === 1" 
                      (click)="onLoginLogsPageChange(loginLogsPage-1)">
                <span class="sm:hidden">‹</span>
                <span class="hidden sm:inline">Anterior</span>
              </button>
              
              <span class="hidden sm:inline text-sm text-gray-600 dark:text-gray-400">
                Página {{loginLogsPage}} de {{loginLogsLastPage}}
              </span>
              
              <button class="px-3 py-2 rounded bg-gray-200 dark:bg-gray-700 text-sm font-medium text-gray-800 dark:text-white disabled:opacity-50" 
                      [disabled]="loginLogsPage === loginLogsLastPage" 
                      (click)="onLoginLogsPageChange(loginLogsPage+1)">
                <span class="sm:hidden">›</span>
                <span class="hidden sm:inline">Siguiente</span>
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
<ng-template #notAllowed>
  <div class="h-screen w-full flex items-center justify-center">
    <div class="bg-red-100 text-red-800 px-6 py-4 rounded shadow text-lg font-semibold">
      No tienes permisos para ver esta sección.
    </div>
  </div>
</ng-template>